import { useState, useEffect } from 'react'
import { Button, Modal } from '@mantine/core'

import { useListState } from '@mantine/hooks'

import ComponentEditableList from './ComponentEditableList'

import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function ComponentEditChildren({
    component,
    editChildrenOpened,
    editChildrenHandlers,
    onSaved,
}) {
    const [isSaving, setIsSaving] = useState(false)

    const initialChildren = component.children.map((child) => ({
        quantity: child.pivot.quantity,
        component_id: child.id,
        full_name: child.component_category.name_fr + ' — ' + child.name,
    }))

    const [children, childrenHandlers] = useListState(initialChildren)

    useEffect(() => {
        if (editChildrenOpened) {
            setIsSaving(false)
            childrenHandlers.setState(initialChildren)
        }
    }, [editChildrenOpened])

    // Save children — the API replaces the whole bundle in one transaction
    const { requestPost } = useAxiosApi()

    const saveChildren = async () => {
        setIsSaving(true)

        await requestPost(`/components/${component.id}/children`, {
            children: children.map((child) => ({
                component_id: child.component_id,
                quantity: child.quantity,
            })),
        })

        // Reload component
        onSaved()

        // Close modal
        editChildrenHandlers.close()
    }

    return (
        <Modal
            opened={editChildrenOpened}
            onClose={editChildrenHandlers.close}
            size="xl"
            centered
            title="Associer des composants pour les assemblages"
            closeOnEscape={false}
        >
            <div className="flex flex-col min-h-[400px]">
                <ComponentEditableList
                    children={children}
                    childrenHandlers={childrenHandlers}
                />

                <div className="flex gap-2 ml-auto">
                    <Button
                        onClick={editChildrenHandlers.close}
                        variant="default"
                    >
                        Annuler
                    </Button>
                    <Button onClick={saveChildren} loading={isSaving}>
                        Sauvegarder les modifications
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
